<script>
import ItemButton from '@/V2/components/ItemButton';
import { iIcon, iSpinner } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';
import { mapGetters } from 'vuex';
import {
  getAgentIconProperties,
  formatAgentRiskLevel,
  formatAgentConfidence,
} from './utils';

export default {
  components: {
    ItemButton,
    iIcon,
    iSpinner,
  },
  data() {
    return {
      palette,
    };
  },
  computed: {
    ...mapGetters(['getDocumentReviewAgentRunsForDocId']),
    latestRun() {
      const runs = this.getDocumentReviewAgentRunsForDocId(
        this.$route.params.document_id,
      );
      return runs?.length > 0 ? runs[runs.length - 1] : null;
    },
    isFailed() {
      return this.latestRun?.status === 'FAILED';
    },
    isRunning() {
      return this.latestRun?.status === 'RUNNING';
    },
    isFinished() {
      return this.latestRun?.status === 'FINISHED';
    },
    itemButtonIconProperties() {
      const properties = {
        symbol: 'medium-user-profile-focus',
        type: 'primary',
      };

      if (this.isRunning || this.isFailed) {
        properties.symbol = 'medium-user-profile-focus';
        properties.type = 'primary';
      } else if (this.isFinished) {
        const riskLevel = this.latestRun?.output.risk_level;
        Object.assign(properties, getAgentIconProperties(riskLevel));
      }
      return properties;
    },
    primaryText() {
      if (this.isRunning || this.isFailed) {
        return 'Document Review Agent';
      } else if (this.isFinished) {
        return formatAgentRiskLevel(this.latestRun?.output.risk_level);
      } else {
        return 'Document Review Agent';
      }
    },
    secondaryText() {
      if (this.isRunning) {
        return 'Generating report...';
      } else if (this.isFailed) {
        return 'Report failed';
      } else if (this.isFinished) {
        return this.formattedConfidence;
      } else {
        return 'Status unknown';
      }
    },
    formattedConfidence() {
      return formatAgentConfidence(
        this.latestRun?.output.confidence,
        this.latestRun?.output.risk_level,
      );
    },
  },
  methods: {
    viewDetails() {
      this.$emit('show-document-review-agent-report');
    },
  },
};
</script>

<template>
  <div
    v-if="latestRun"
    class="document-review-agent-report-button d-flex flex-column align-items-start justify-content-between i-pb-10"
  >
    <!-- Document Review Agent Report Button -->
    <item-button
      class="document-review-agent-report-button__button"
      :class="{ 'failed-border': isFailed }"
      :icon="itemButtonIconProperties.symbol"
      :icon-type="itemButtonIconProperties.type"
      :primary-text="primaryText"
      :secondary-text="secondaryText"
      :on-btn-click="viewDetails"
      :disabled="!isFinished"
    >
      <template slot="icon-coin">
        <i-icon
          v-if="isFailed"
          symbol="medium-alert-circle"
          :size="16"
          :colour="palette['light-error-90']"
        ></i-icon>
        <i-spinner v-else-if="isRunning" size="md"></i-spinner>
      </template>
    </item-button>
  </div>
</template>

<style lang="scss" scoped>
.document-review-agent-report-button {
  &__button {
    &:hover {
      background-color: $light-neutral-10;
    }
  }

  .failed-border {
    border: 1px solid $light-error-60;

    &:hover {
      border: 1px solid $light-error-60;
    }
  }
}
</style>
